import { RegistryService } from './../registry/registry.service';
import { Observable } from 'rxjs/Observable';

import { forkJoin } from 'rxjs/observable/forkJoin';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Gift } from './../gift/gift';
import { NavigationEnd, Router } from '@angular/router';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { UserService } from './../user/user.service';
import { AuthService, User } from './../user/auth.service';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Registry } from '../registry/registry';
import { Subject } from 'rxjs/Subject';
import { Settings } from '../settings/settings';
import { Contribution } from '../track/contribution';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  // styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnInit, OnDestroy {
  contributionLimit = 0;
  
  showMobileMenu = false;
  alerts = 0;
  registry: Registry;
  gifts: Gift[];
  contributions: Contribution[];
  user:User;
  isAnonmyousMode = false;
  settings: Settings;
  private ngUnsubscribe: Subject<void> = new Subject();
  currentPosition: number;
  hideMobileMenu: boolean;
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private _registryFirebaseService: RegistryFirebaseService,
    private _registryService: RegistryService
  ) {

    if (this._registryFirebaseService.registry) {
      this.registry = this._registryFirebaseService.registry;
    }
  }


  ngOnInit() {
this.isAnonmyousMode = this._registryFirebaseService.isAnonRegPath()

//on route change close the mobile menu
this.router.events.subscribe(event => {
  if (event instanceof NavigationEnd) {
    this.showMobileMenu = false;
  }
});


if (!this.isAnonmyousMode){
    const combined = combineLatest(
      this.authService.user,
      this._registryFirebaseService.currentGifts
    ).take(1).subscribe(latestValues => {

      this.user = latestValues[0];
      this.gifts = latestValues[1];

      if (this.user) {
        this._registryFirebaseService.getSettingsByUserId(this.user.uid).takeUntil(this.ngUnsubscribe).subscribe(settings => {
          this.settings = settings;

          if (!this.registry) {
            this.registry = this._registryService._registry;
          }
          if (this.user && this.registry && (this.registry.hasCustomPaymentMethods || (this.settings && this.settings.stripeAccountId))){

          }
        });
      }
      this.userService.headerTypeEmitted$.subscribe(header => {
        // this.headerType = header;
        if (header === 'showMobileMenu') {
          this.showMobileMenu = true;

          const body = document.getElementsByTagName('body')[0];
          body.style.overflow = 'hidden';

          
            this.getContribs(null);
          
        }


      });


    });
  } else {
    this.userService.headerTypeEmitted$.subscribe(header => {
      // this.headerType = header;
      if (header === 'showMobileMenu') {
        this.showMobileMenu = true;

        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'hidden';
        
         
        
      }
    })
  }

  }


  openPopup(popupType) {
    this.close();
    this._registryService.emitGenricPopup(popupType);
  }

  launchClick() {
    if (!this.registry.paid && (!this.registry.hasCustomPaymentMethods)) {
      this.router.navigate(['/registry/add-payment-methods']);
    } else if (!this.registry.paid && (this.registry.hasCustomPaymentMethods)) {
      this.router.navigate(['/visibility']);
    } else {
      this.router.navigate(['/registry/publish/step-3']);
    }
  }
  openPreview() {
    this.router.navigateByUrl("/" + this.registry.registryName + "?preview=1");
  }

  getContribs(gifts: Gift[]) {
    this._registryFirebaseService.getContributions(gifts).subscribe(contributions => {
      this.contributions = contributions;
      this.alerts = contributions.filter(x => x.seen !== true).length;
      this.contributionLimit = this._registryFirebaseService.getContributionLimit(this.registry);
    });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  closeRedirectToReg() {
    this.showMobileMenu = false;
    this.router.navigate(['registry']);
  }
  close() {
    this.showMobileMenu = false;

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';


  }

  closeAndOpenRef(){
    this._registryService.emitGenricPopup('referral');
    this.close();


  }
}



// WEBPACK FOOTER //
// ./src/app/mobile-menu/mobile-menu.component.ts